module.exports = __webpack_public_path__ + "static/media/placeholder.cb979a51.png";